// 筛选框的宽度按文字算：el-input / el-select 没有「按内容撑开」的能力，
// 英文的提示文字比中文长一截，写死宽度会被截断。
// 字体取页面全局的（body 上的那套），不在这里另定字号

let ctx = null

function textWidth(text) {
  if (!ctx) ctx = document.createElement('canvas').getContext('2d')
  const style = window.getComputedStyle(document.body)
  ctx.font = style.fontSize + ' ' + style.fontFamily
  return Math.ceil(ctx.measureText(String(text || '')).width)
}

// el-input 左右 padding 15 + 边框 1；el-select 右边还要给箭头留 30
const PAD = { input: 32, select: 47 }

// 取几段文字里最宽的那段，加上框自己的内边距，夹在 min ~ max 之间
export function fitWidth(texts, { type = 'input', min = 160, max = 320 } = {}) {
  const list = Array.isArray(texts) ? texts : [texts]
  const widest = list.reduce((w, t) => Math.max(w, textWidth(t)), 0)
  return Math.min(Math.max(widest + PAD[type], min), max) + 'px'
}

export default { fitWidth }
